import { useEffect } from "react";

declare global {
  interface Window {
    piAId: string;
    piCId: string;
    piHostname: string;
    attachEvent(event: string, listener: EventListener): boolean;
  }
}

window.piAId = "970993";
window.piCId = "1690";
window.piHostname = "pi.pardot.com";

const usePardot = (): void => {
  useEffect(() => {
    (() => {
      const asyncLoad = () => {
        const s = document.createElement("script");

        s.type = "text/javascript";
        s.src = `${
          document.location.protocol === "https:" ? "https://pi" : "http://cdn"
        }.pardot.com/pd.js`;

        const c = document.getElementsByTagName("script")[0];

        c.parentNode?.insertBefore(s, c);
      };

      if (window.attachEvent) {
        window.attachEvent("onload", asyncLoad);
      } else {
        window.addEventListener("load", asyncLoad, false);
      }
    })();
  }, []);
};

export default usePardot;
